var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 12.2857,
    fill: "url(#paint0_linear_1051_20197)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1191 9.21387H12.6261C10.7422 9.21387 9.21484 10.7411 9.21484 12.6251V31.1181C9.21484 33.0022 10.7421 34.5293 12.6261 34.5293H21.7466L21.7624 25.4832H19.4119C19.1065 25.4832 18.8586 25.2362 18.8575 24.9307L18.8461 22.0146C18.8448 21.7077 19.0937 21.4579 19.4006 21.4579H21.7469V18.6404C21.7469 15.3706 23.7439 13.5902 26.6607 13.5902H29.0543C29.3603 13.5902 29.6089 13.8385 29.6089 14.1448V16.6035C29.6089 16.9098 29.3606 17.158 29.0546 17.158L27.5856 17.1589C25.9994 17.1589 25.6921 17.9126 25.6921 19.019V21.4583H29.1776C29.51 21.4583 29.7676 21.7484 29.7283 22.0779L29.3827 24.9941C29.3498 25.2733 29.113 25.4834 28.832 25.4834H25.7078L25.692 34.5298H31.119C33.0029 34.5298 34.5302 33.0024 34.5302 31.1185V12.6251C34.5303 10.7412 33.003 9.21387 31.1191 9.21387Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7458 34.5295L21.7617 25.4834H21.7227V34.5295H21.7458Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1051_20197",
    x1: 21.5,
    y1: 0,
    x2: 21.5,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B73E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2840B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFb);
export default __webpack_public_path__ + "static/media/share-fb.e3374b42c7fca59b0a6120bdb479a3c9.svg";
export { ForwardRef as ReactComponent };